<template>
  <div id="app">
    <header class="container-fluid">
      <div class="container">
        <!-- NAVBAR (Меню для мониторов)============================================================ -->
        <b-navbar
            type="light"
            class="navbar-expand-lg"
            variant="white"
            toggleable="lg"
        >
          <b-navbar-brand href="/" id="a-root-id">
            <div class="logo-wrapper xxs">
              <div class="logo"></div>
              <div class="text d-none d-sm-block">
                <h1 v-if="$store.getters.isAdmin">
                  {{ $t("menu.admin.title") }}
                </h1>
                <h1 v-else>{{ $t("app.name") }}</h1>
              </div>
            </div>
          </b-navbar-brand>

          <b-navbar-toggle target="sidebar-menu"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <!--
              <b-nav-item-dropdown right>
                <template v-slot:button-content>
                  <em>{{ $t("menu.support._") }}</em>
                </template>
                <b-dropdown-item href="#">{{
                  $t("menu.support.community")
                }}</b-dropdown-item>
                <b-dropdown-item href="#">{{
                  $t("menu.support.contactUs")
                }}</b-dropdown-item>

                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-text>{{
                  $t("menu.support.demoNote")
                }}</b-dropdown-text>
              </b-nav-item-dropdown>
              -->

              <!-- Языки ============================================= -->
              <b-nav-item-dropdown v-if="locales && locales.length > 1" right>
                <template v-slot:button-content>
                  <span class="globe">{{ $i18n.locale }}</span>
                </template>
                <b-dropdown-item
                    v-for="(item, index) in locales"
                    :key="index"
                    @click="onLocaleClick(item.code)"
                    v-bind:active="isCurrentLocale(item.code)"
                >{{ item.name }}
                </b-dropdown-item>
              </b-nav-item-dropdown>

              <!-- Меню пользователя ================================== -->
              <b-nav-item-dropdown
                  v-if="$store.getters.isComplete()"
                  right
                  no-caret
                  class="user"
              >
                <b-dropdown-text id="user-info">
                  <div class="avatar"></div>
                  <div class="info">
                    <div class="name">{{ $store.getters.name }}</div>
                  </div>
                </b-dropdown-text>
                <template v-if="$store.state.user.verified">
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item v-if="$store.getters.isAdmin" to="/admin">{{
                      $t("menu.user.account")
                    }}
                  </b-dropdown-item>
                  <b-dropdown-item v-else to="/dashboard">{{
                      $t("menu.user.account")
                    }}
                  </b-dropdown-item>
                  <b-dropdown-item to="/dashboard/profile">{{
                      $t("menu.user.profile")
                    }}
                  </b-dropdown-item>
                </template>
                <b-dropdown-divider></b-dropdown-divider>
                <template v-slot:button-content>
                  <div class="avatar"></div>
                </template>
                <b-dropdown-item @click="onSignOutClick()">{{
                    $t("menu.user.signout")
                  }}
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>

        <!-- SIDEBAR (Меню для телефонов)============================================================ -->
        <b-sidebar
            id="sidebar-menu"
            title="Меню"
            backdrop-variant="dark"
            bg-variant="white"
            backdrop
            shadow
            right
        >
          <template #default="{ hide }">
            <b-nav vertical justified>
              <b-nav-item @click="handleCreateClick()">{{ $t('menu.new') }}</b-nav-item>
              <template v-if="$store.state.user.verified">
                <div class="separator">
                  <hr
                      role="separator"
                      aria-orientation="horizontal"
                      class="dropdown-divider"
                  />
                </div>
                <b-nav-item
                    v-if="$store.getters.isAdmin"
                    to="/admin"
                    @click="hide"
                >{{ $t("menu.user.account") }}
                </b-nav-item
                >
                <b-nav-item v-else to="/dashboard" @click="hide">{{
                    $t("menu.user.account")
                  }}
                </b-nav-item>
              </template>

              <div class="separator">
                <hr
                    role="separator"
                    aria-orientation="horizontal"
                    class="dropdown-divider"
                />
              </div>
              <b-nav-item to="/dashboard/profile" @click="hide">
                <div class="d-flex">
                  <div class="avatar"></div>
                  <div class="v-center">
                    {{ $t("menu.user.profile") }}
                  </div>
                </div>
              </b-nav-item
              >
              <div class="separator">
                <hr
                    role="separator"
                    aria-orientation="horizontal"
                    class="dropdown-divider"
                />
              </div>
              <b-nav-item @click="onSignOutClick()">{{
                  $t("menu.user.signout")
                }}
              </b-nav-item>
            </b-nav>
          </template>
        </b-sidebar>
      </div>
    </header>

    <!-- CONTENT =================================================================== -->
    <!-- Здесь два варианта:                                                         -->
    <!--  1. Центрированная форма типа login/register/remember                       -->
    <!--  2. Страница приложения с меню                                              -->
    <!-- router > route > meta > menuless: true                                      -->
    <div id="main" class="fh-container" v-bind:class="variantObject">
      <router-view/>
    </div>

    <!-- FOOTER ==================================================================== -->
    <footer id="footer">
      <b-container>
        <div class="row">
          <div class="col-12 col-md-8" role="legal">
            <div class="links">
              <a :href="URL_PRIVACY_POLICY">Privacy Policy</a><span
                class="spacer"></span><a :href="URL_TERMS_OS_SERVICE">Terms of Service</a>
            </div>
            <div class="dim">All trademarks are the property of their respective owners.</div>
            <div class="dim">&copy; 2020-23 DBinvent LLC</div>
          </div>
          <div class="col-12 order-first col-md-4 order-md-last" role="nav">
            <div class="links">
              <a :href="URL_QUICK_START_GUIDE">
                <!--
                <svg height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" xmlns:v="https://vecta.io/nano"><path d="M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6h0zM128 134a6.02 6.02 0 0 1 6-6h212a6.02 6.02 0 0 1 6 6v20a6.02 6.02 0 0 1-6 6H134a6.02 6.02 0 0 1-6-6v-20zm0 64a6.02 6.02 0 0 1 6-6h212a6.02 6.02 0 0 1 6 6v20a6.02 6.02 0 0 1-6 6H134a6.02 6.02 0 0 1-6-6v-20zm253.4 250H96a31.97 31.97 0 0 1-32-32c0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z" fill="#a8a9aa"/></svg>
                -->
                Documentation
              </a><span
                class="spacer"></span><a :href="URL_SETUP_DOWNLOAD">
              <!--
              <svg height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" xmlns:v="https://vecta.io/nano"><path d="M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z" fill="#a8a9aa"/></svg>
              -->
              Downloads
            </a>
            </div>
          </div>
        </div>
      </b-container>
    </footer>
  </div>
</template>

<script>
import {getSupportedLocales} from "@/util/supported-locales";
import {
  setDocumentDirectionPerLocale,
  setDocumentTitle,
  setDocumentLang,
} from "@/util/document-locale";
import store from "@/store/";
import {SET_LOCALE, SIGN_OUT} from "@/store/consts";
import {
  licenseObject,
  UNSAVED_LICENSE_ID,
} from "@/components/rdbm/license.js";
import {URL_TERMS_OS_SERVICE, URL_PRIVACY_POLICY, URL_SETUP_DOWNLOAD, URL_QUICK_START_GUIDE} from "@/globals";

export default {
  data: () => ({
    locales: getSupportedLocales(),
  }),
  methods: {
    isCurrentLocale(code) {
      return code === this.$store.state.locale;
    },
    onLocaleClick: function (code) {
      store.dispatch(SET_LOCALE, code);
    },
    onSignOutClick: function () {
      store.commit(SIGN_OUT);
      this.$route.params.nextUrl = null;
      this.$router.push("/sign-in");
    },
    handleCreateClick: function () {
      this.$router.push({
        name: "rdbmItem",
        params: {
          id: UNSAVED_LICENSE_ID + licenseObject.lastId(),
          // item: null,
          // licenses: this.licenses,
        },
      });
    },
  },
  computed: {
    menuless: function () {
      return this.$route.matched.some((record) => record.meta.menuless);
    },
    variantObject: function () {
      return {
        "v-center": this.menuless,
        "v-padded": this.menuless,
        "with-menu": !this.menuless,
      };
    },
  },
  mounted() {
    store.dispatch("init");

    this.$watch(
        "$i18n.locale",
        (newLocale, oldLocale) => {
          if (newLocale === oldLocale) {
            return;
          }
          setDocumentLang(newLocale);
          setDocumentDirectionPerLocale(newLocale);
          setDocumentTitle(this.$t("app.name"));
        },
        {immediate: true}
    );
  },
  created() {
    this.UNSAVED_LICENSE_ID = UNSAVED_LICENSE_ID;
    this.licenseObject = licenseObject;
    this.URL_TERMS_OS_SERVICE = URL_TERMS_OS_SERVICE;
    this.URL_PRIVACY_POLICY = URL_PRIVACY_POLICY;
    this.URL_SETUP_DOWNLOAD = URL_SETUP_DOWNLOAD;
    this.URL_QUICK_START_GUIDE = URL_QUICK_START_GUIDE;
  }
};
</script>

<style>
@import "common.scss";

@font-face {
  font-family: "Roboto";
  src: local("Roboto"),
  url(./assets/fonts/roboto/roboto_regular/Roboto-Regular-webfont.woff) format("woff");
}

@font-face {
  font-family: "Roboto L";
  src: local("Roboto L"),
  url(./assets/fonts/roboto/roboto_light/Roboto-Light-webfont.woff) format("woff");
}

:root {
  --main-font-family: "Roboto", -apple-system, system-ui, BlinkMacSystemFont,
  "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  --header-top-border: 4px solid #238dd4;
  --default-border: 1px solid rgb(209 214 214);
  --default-border-radius: 6px;
  --panel-bg-color: rgba(238, 238, 238, 0.63);
}

#app {
  font-family: var(--main-font-family);
  letter-spacing: 0.0125em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1d1d1f;
  min-height: 100vh;
  flex-direction: column;
  display: flex;
}

@media screen and (max-width: 767px) {
  body {
    font-size: 0.95rem;
  }
}

#app .with-menu #content {
  margin-top: 3em;
  padding: 0;
}

.fh-container {
  display: flex;
  flex-direction: column;
}

.fh-area {
  flex-grow: 20;
}

h1 {
  color: #1d1d1d;
}

header {
  z-index: 1000;
  min-height: 59px;
  border-top: var(--header-top-border);
  border-bottom: var(--default-border);
  display: flex;
}

header .navbar {
  padding: 0.5em 0;
}

header .logo-wrapper {
  display: flex;
}

header .logo-wrapper * {
  margin: 0;
  padding: 0;
  color: dimgrey;
}

header .logo-wrapper .logo {
  height: 50px;
  width: 50px;
  content: "";
  display: inline-block;
  background-image: url(./assets/logo.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 24px;
}

@media screen and (max-width: 576px) {
  .navbar-brand {
    padding: 0;
  }

  header .logo-wrapper .logo {
    height: 40px;
    width: 40px;
  }
}

header .logo-wrapper h1 {
  line-height: 50px;
  font-size: 24px;
}

header .globe::before {
  content: "";
  width: 20px;
  height: 20px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='420' height='420' style='fill:none;stroke:%23000'%3E%3Cpath d='M209 15a195 195 0 1 0 2 0z' stroke-width='30'/%3E%3Cpath d='m210 15v390m195-195H15M59 90a260 260 0 0 0 302 0m0 240a260 260 0 0 0-302 0M195 20a250 250 0 0 0 0 382m30 0a250 250 0 0 0 0-382' stroke-width='20'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: inline-block;
  vertical-align: -0.255em;
  margin-right: 8px;
  opacity: 0.5;
}

header .user a.dropdown-toggle {
  height: 43px;
  width: 55px;
  padding: 5px 0 5px 12px;
}

header .user a img {
  height: 33px;
  width: 33px;
}

header .avatar {
  height: 33px;
  width: 33px;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAwIDEwMDAiPjxwYXRoIGQ9Ik01MDAgMTBDMjI5LjggMTAgMTAgMjI5LjggMTAgNTAwYzAgMjcwLjEgMjE5LjggNDkwIDQ5MCA0OTAgMjcwLjEgMCA0OTAtMjE5LjkgNDkwLTQ5MCAwLTI3MC4yLTIxOS45LTQ5MC00OTAtNDkwem0wIDcwYzIzMS45IDAgNDIwIDE4OC4yIDQyMCA0MjAgMCA5My43LTMxIDE3OS44LTgyLjggMjQ5LjYtNTEtODAtMTI4LjktMTQxLTIyMS41LTE2OC42IDU0LjItMzcuMSA4OS45LTk5LjMgODkuOS0xNjkuOCAwLTExMy40LTkyLjItMjA1LjctMjA1LjctMjA1LjctMTEzLjQgMC0yMDUuNyA5Mi4zLTIwNS43IDIwNS43IDAgNzEuMSAzNi4zIDEzMy44IDkxLjMgMTcwLjctOTIuNSAyOC41LTE3MC4zIDkwLjItMjIwLjYgMTcwLjhDMTExLjkgNjgyLjMgODAgNTk1IDgwIDUwMCA4MCAyNjguMSAyNjguMSA4MCA1MDAgODB6TTM2NC40IDQxMS4yYzAtNzQuOCA2MC44LTEzNS43IDEzNS43LTEzNS43czEzNS43IDYwLjggMTM1LjcgMTM1LjctNjEgMTM1LjctMTM1LjcgMTM1LjdTMzY0LjQgNDg2IDM2NC40IDQxMS4yek0yMTQuNSA4MDcuNGM1NS4zLTEwMi44IDE2My0xNzMuMiAyODcuNi0xNzMuMiAxMjMuNiAwIDIzMC41IDY5LjEgMjg2LjQgMTcwLjNDNzEzLjMgODc2IDYxMS45IDkyMCA1MDAgOTIwYy0xMTAuNCAwLTIxMC41LTQyLjktMjg1LjUtMTEyLjZ6Ii8+PC9zdmc+");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

header #user-info {
  display: flex;
}

header #user-info .info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  white-space: nowrap;
  padding-left: 0.75rem;
}

header #user-info .name {
  font-weight: bold;
}

header a:hover .globe::before {
  opacity: 1;
}

section {
  margin: 3em 0 0 0;
}

section:first-child {
  margin: 1em 0 0 0;
}

#menu {
  background-color: var(--panel-bg-color);
}

#menu .nav-link {
  color: #616161;
  opacity: 0.75;
  font-size: 15px;
  padding: 1rem;
}

#menu .nav-link.active {
  border-bottom: 3px solid #3cb1ff;
  opacity: 1;
}

.b-sidebar-body .nav-link {
  color: #212529;
}

.b-sidebar-body .avatar {
  margin-right: 0.5em;
}

.b-sidebar-body .nav-link:hover {
  background-color: var(--panel-bg-color);
}

.b-sidebar-body .separator a {
  padding: 0;
}

.b-sidebar-body .separator .text {
  padding: 0 1rem;
  font-size: 80%;
  color: var(--gray-600);
}

.b-sidebar-body .nav .nav-item:first-child {
  margin-top: 0.5em;
}

h2 {
  font-size: 25px;
  font-weight: 600;
}

#main {
  flex: 2;
}

#content .router {
  margin: 2em 0 -2em;
  padding-bottom: 2em;
}

#content .router a:not(:last-child) {
  margin-right: 2em;
}

section.dark {
  background-color: #F0F4F7;
}

section {
  padding: 4rem 0;
}

.buttons button:not(:first-child) {
  margin-left: 16px;
}

.form-group small.form-text {
  font-size: 15px;
  padding-left: 2.25rem;
}

#footer {
  background-color: #27282c;
  border-top: 1px solid rgb(234, 235, 235);
  color: #f8f9fa;
  font-size: 0.8rem;
  line-height: 1.9;
  padding: 2em 0;
  margin: 0;
}

#footer a, #footer a:hover {
  color: #E9ECEFFF;
}

#footer a {
  opacity: 0.75;
  text-decoration: none;
}

#footer .spacer {
  margin: 0 0.3rem;
}

#footer .spacer::before {
  content: " \2027";
}

#footer .links {
  margin-bottom: 1em;
}

#footer .dim {
  opacity: .35;
}

#footer [role*="nav"] {
  align-items: center;
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 576px) {
  #footer [role*="nav"] {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  #footer [role*="legal"] {
    text-align: center;
  }
}

@media screen and (max-width: 340px) {
  .xxs {
    display: none !important;
  }
}

.mb-2rem {
  margin-bottom: 2rem;
}

.debug-panel pre {
  max-height: 250px;
  min-height: 250px;
  margin: 0;
}

.debug-enabler {
  position: fixed;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
}

.modal-body.nice-modal {
  padding: 2rem !important;
}

@media screen and (max-width: 490px) {
  .modal-body.nice-modal {
    padding: 1rem !important;
  }
}

@media screen and (min-width: 576px) {
  .modal-body.nice-modal {
    padding: 2rem 3rem !important;
  }
}

.modal-footer {
  padding: 0.75rem 0.5rem;
}

.modal-footer button {
  min-width: 4rem;
  margin: 0.5rem;
}

.hide-cancel .btn-secondary {
  display: none;
}

.t90p {
  font-size: 90%;
}

.t85p {
  font-size: 85%;
}

code {
  display: block;
  color: white;
  padding: 0.5em 1em;
  margin: 1em 0;
  position: relative;
  background-color: #4e525a;
  border-radius: 6px;
}

.expires {
  color: #f65858;
  opacity: 1;
}
</style>
